module.exports = __webpack_public_path__ + "static/media/botimage2.43e2aabf.jpg";